import { createContext } from "react";

import {
  noop,
  TNeighborAreaSettingsState,
  TNewNeighborAreaSettings,
} from "@ryde/shared";

interface INeighborAreasTemplateContext {
  fieldName: string;
  availableAreas: number[];
  companyId?: number;
  onAdd: (neighborAreaSettings: TNewNeighborAreaSettings) => void;
  onEdit: (args: {
    tmpId: string;
    neighborAreaSettings: TNeighborAreaSettingsState;
  }) => void;
  onRemove: (tmpId: string) => void;
  onInnerEditStart: () => void;
  onInnerEditEnd: () => void;
}

const defaultValue: INeighborAreasTemplateContext = {
  fieldName: "",
  availableAreas: [],
  companyId: undefined,
  onAdd: noop,
  onEdit: noop,
  onRemove: noop,
  onInnerEditStart: noop,
  onInnerEditEnd: noop,
};
export const NeighborAreasTemplateContext =
  createContext<INeighborAreasTemplateContext>(defaultValue);
